import React from "react";
import { Icon } from "@shopify/polaris";
import { CircleTickMajor } from "@shopify/polaris-icons";

interface Props {
    hasCheckList: boolean;
}

export default function CheckListIcon({ hasCheckList }: Props) {
    return hasCheckList ? (
        <Icon color="success" source={CircleTickMajor} />
    ) : (
        <div>-</div>
    );
}
